import { render } from "./Authenticator.vue?vue&type=template&id=2ca849b6&lang=pug"
import script from "./Authenticator.vue?vue&type=script&lang=js"
export * from "./Authenticator.vue?vue&type=script&lang=js"

import "./Authenticator.vue?vue&type=style&index=0&id=2ca849b6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__